import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
export const MemberHomeProfileTabDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MemberHomeProfileTab"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"aaBlockSyncUntil"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"idEnterprise"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"MemberHomeProfileTab","document":MemberHomeProfileTabDocument}} as const;
export type MemberHomeProfileTabQueryVariables = Types.Exact<{
  memberId: Types.Scalars['ID']['input'];
}>;


export type MemberHomeProfileTabQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id' | 'aaBlockSyncUntil' | 'bio' | 'idEnterprise' | 'username'>
  )> }
);

/**
 * __useMemberHomeProfileTabQuery__
 *
 * To run a query within a React component, call `useMemberHomeProfileTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberHomeProfileTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberHomeProfileTabQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useMemberHomeProfileTabQuery(
  baseOptions: TrelloQueryHookOptions<
    MemberHomeProfileTabQuery,
    MemberHomeProfileTabQueryVariables
  > &
    (
      | { variables: MemberHomeProfileTabQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: MemberHomeProfileTabDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    MemberHomeProfileTabQuery,
    MemberHomeProfileTabQueryVariables
  >(MemberHomeProfileTabDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useMemberHomeProfileTabLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    MemberHomeProfileTabQuery,
    MemberHomeProfileTabQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MemberHomeProfileTabQuery,
    MemberHomeProfileTabQueryVariables
  >(MemberHomeProfileTabDocument, options);
}
export function useMemberHomeProfileTabSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        MemberHomeProfileTabQuery,
        MemberHomeProfileTabQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MemberHomeProfileTabQuery,
    MemberHomeProfileTabQueryVariables
  >(MemberHomeProfileTabDocument, options);
}
export type MemberHomeProfileTabQueryHookResult = ReturnType<
  typeof useMemberHomeProfileTabQuery
>;
export type MemberHomeProfileTabLazyQueryHookResult = ReturnType<
  typeof useMemberHomeProfileTabLazyQuery
>;
export type MemberHomeProfileTabSuspenseQueryHookResult = ReturnType<
  typeof useMemberHomeProfileTabSuspenseQuery
>;
export type MemberHomeProfileTabQueryResult = Apollo.QueryResult<
  MemberHomeProfileTabQuery,
  MemberHomeProfileTabQueryVariables
>;
